import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../components/modal/modal.component';
import {StyledFooter} from "../../components/pane/pane.style";
import Form from "../../components/form";
import {StyledModalContent} from "../../components/modal/modal.style";
import {disableSwipeToClose} from "../../utils/tools/modals";
import {useIonViewDidEnter} from "@ionic/react";
import {Preferences} from "@capacitor/preferences";
import {StyledWiteButton} from "@components/button/button.style";


type PropagationPhoneModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onReject: () => void;
    onSign: () => void;
};

const PropagationPhoneSignModal: React.FC<PropagationPhoneModalProps> = (props: PropagationPhoneModalProps) => {

    const {t} = useTranslation();

    const [userPhone, setUserPhone] = useState<string | null>('');

    useEffect(() => {
        fetchUserData();
    }, []);

    useIonViewDidEnter(() => {
        fetchUserData();
    });

    const fetchUserData = async () => {
        let phone = await Preferences.get({'key': 'phone'});
        let phoneCode = await Preferences.get({'key': 'phone_code'});
        if (phone.value) {
            setUserPhone('+' + phoneCode.value + ' ' + phone.value);
        }

    }
    return (
        <>

            <Modal
                isOpen={props.isOpen}
                maxHeight={'95%'}
                canDismiss={disableSwipeToClose}
                disableClose={true}
                onDidDismiss={() => props.onClose()}>

                <StyledModalContent>
                    <h1 className="title">{t("propagation.phone.title")}</h1>

                    <div className="content">
                        {t("propagation.phone.text", {phone: userPhone})}

                        <StyledFooter className="modal footer no-shadow">
                            <StyledWiteButton type="button" className="red"
                                              onClick={() => props.onReject()}>{t("propagation.rejectButton")}</StyledWiteButton>
                            <Form.Button onClick={() => props.onSign()}>{t("propagation.acceptButton")}</Form.Button>
                        </StyledFooter>
                    </div>

                </StyledModalContent>
            </Modal>
        </>
    );
};

export default PropagationPhoneSignModal;